module.exports = __webpack_public_path__ + "img/cobertura_promedio.14ea9429.jpg";